import Login from "../containers/Login";

import userRoutes from "./modules/user";
import passwordRoutes from "./modules/password";

const systemRoutes = [
  ...userRoutes,
  ...passwordRoutes,
  {
    path: "/login",
    exact: true,
    auth: false,
    component: Login
  }
];

export default systemRoutes;



// WEBPACK FOOTER //
// ./src/system/routes/index.jsx